<template>
  <el-dialog title="防伪码包明细"
             append-to-body
             :visible.sync="visible"
             width="560px"
             @close='handleClose'
             :close-on-press-escape="false">
    <el-table border
              v-loading="loading"
              :data="list">
      <el-table-column label="标签序号"
                       min-width="180">
        <template slot-scope="{row}">
          {{row.beginTagNo | tagCount() }} - {{row.endTagNo | tagCount() }}
        </template>
      </el-table-column>
      <el-table-column label="开通状态"
                       min-width="80"
                       prop="statusName">
      </el-table-column>
    </el-table>
    <el-pagination background
                   @current-change="handleCurrentChange"
                   :current-page.sync="config.pageNum"
                   :page-size="config.pageSize"
                   layout="total, prev, pager, next"
                   :total="total">
    </el-pagination>
    <template slot="footer">
      <el-button @click="visible = false"
                 :loading="loading">关 闭</el-button>
    </template>
  </el-dialog>
</template>
<script>
import Hundun from '@/service/hundun'
export default {
  name: 'security-action-list-modal',
  components: {},
  data () {
    return {
      loading: false,
      visible: false,
      config: { tagSegDetailsId: null, pageNum: 1, pageSize: 10 },
      list: [],
      total: 0
    }
  },
  methods: {
    handleClose () {
      this.list = []
      this.total = 0
      this.config = { ...this.config, ...this.$options.data().config }
    },
    getsetassigns () {
      this.loading = true
      Hundun.gettagseg4securitys({ ...this.config })
        .then(res => {
          const { result, message, records, total } = res.data
          this.loading = false
          if ([0].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.getsetassigns()
    },
    fetch (options) {
      this.config.tagSegDetailsId = options.tagSegDetailsId
      this.visible = true
      this.getsetassigns()
    }
  }
}
</script>
